import * as React from 'react';
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
/*import {useContext} from "react";
import {AuthUserContext} from "../../providers/AuthProvider";
import Button from "@mui/material/Button";*/
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import {Button, Grid, Tooltip} from "@mui/material";
import {HelpOutlineOutlined} from "@mui/icons-material";
import firebase, {logout} from "../../firebase/firebase";
import AlertDialog from "../../components/AlertDialog";
import Portal from "@mui/material/Portal";
import Dialog from "@mui/material/Dialog/Dialog";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle";
import DialogContent from "@mui/material/DialogContent/DialogContent";
import DialogContentText from "@mui/material/DialogContentText/DialogContentText";
import DialogActions from "@mui/material/DialogActions/DialogActions";
export default function ResetPassword() {
  const navigator = useNavigate()
  const [query] = useSearchParams()
  const [open, setOpen] = React.useState(false)

  const [values, setValues] = React.useState({
    oldpassword: '',
    newpassword: '',
    confirmpassword: '',
    showoldPassword: false,
    shownewPassword: false,
    showconfirmPassword: false,
  });
  const [newPasswordError,setNewPasswordError] = React.useState("");
  const [confirmPasswordError,setConfirmPasswordError] = React.useState("");
  const [updateStatus, setUpdateStatus] = React.useState("")
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showoldPassword: !values.showoldPassword,

    });
  };

  const handleClickNewShowPassword = () => {
    setValues({
      ...values,
      shownewPassword: !values.shownewPassword,
    });
  };

  const handleClickConfirmShowPassword = () => {
    setValues({
      ...values,
      showconfirmPassword: !values.showconfirmPassword,
    });
  };


  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  console.log(query.get('oobCode'))
  const handleValidation = (event) => {
    event.preventDefault();
    const value= event.target.value.trim();
    const passwordInputFieldName = event.target.name;

    // for new password

    if(passwordInputFieldName === 'newpassword'){
      const uppercaseRegExp = /(?=.*?[A-Z])/;
      const lowercaseRegExp = /(?=.*?[a-z])/;
      const digitsRegExp = /(?=.*?[0-9])/;
      const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
      const minLengthRegExp   = /.{8,}/;

      const passwordLength =      value.length;
      const uppercasePassword =   uppercaseRegExp.test(value);
      const lowercasePassword =   lowercaseRegExp.test(value);
      const digitsPassword    = digitsRegExp.test(value);
      const specialCharPassword = specialCharRegExp.test(value);
      const minLengthPassword =   minLengthRegExp.test(value);


      if(passwordLength===0)
      {setNewPasswordError("Your Password is empty.")}
      else if(!uppercasePassword)
      {setNewPasswordError("Your password must have at least one uppercase.")}
      else if(!lowercasePassword)
      {setNewPasswordError("Your password must have at least one lowercase.")}
      else if(!digitsPassword)
      {setNewPasswordError("Your password must have at least one number.")}
      else if(!specialCharPassword)
      {setNewPasswordError("Your password must have at least one special character.")}
      else if(!minLengthPassword)
      {setNewPasswordError("Your password must have at least 8 characters.")}
      else{
        setNewPasswordError("");
        // sethasError(false);
      }

    }

    // Confirm Password

    if(passwordInputFieldName=== "confirmpassword" || (passwordInputFieldName==="newpassword" && values.confirmpassword.length>0)){

      if(values.confirmpassword!==values.newpassword)
      { setConfirmPasswordError("Please make sure your passwords match.")
      }
      else{
        setConfirmPasswordError("");
      }
    }
  }

  const handleSubmit = async (e) =>{
    e.preventDefault();
    setUpdateStatus("")
    if(!newPasswordError && !confirmPasswordError){
       firebase.auth().confirmPasswordReset(query.get('oobCode'), values.newpassword)
         .then(() => {
           setOpen(true)
         })
         .catch((err) => {
           debugger
           console.log(err)
         })
    }
  }
  return(
    <Container  maxWidth="md" component="main" sx={{height: 'calc(100vh - 120px)', p: 5}}>

      <Stack
        direction="column"
        justifyContent="center"
        alignItems="flex-start"
        spacing={2}
        onSubmit={handleSubmit}
      >
        <Typography variant={'h6'} sx={{textAlign: 'left'}}>
          Reset your password
        </Typography>


          <FormControl fullWidth sx={{ width: '100%'}} variant="outlined" >
            <InputLabel htmlFor="outlined-adornment-password" sx={{display:"flex", flexDirection:"row"}}>New Password
              <Tooltip
                componentsProps={{
                  tooltip: {
                    sx: {
                      maxWidth: "150px",
                      bgcolor: '#204488',
                      '& .MuiTooltip-arrow': {
                        color: '#204488',
                      },
                    },
                  },
                }}
                title={<>Password must have : <br/> 1 Uppercase <br/>1 Lowercase <br/>1 Number <br/>1 Special character <br/>8 Characters </>} arrow sx={{width:"100px"}} placement="top-start">
                <HelpOutlineOutlined sx={{borderRadius:"100%", ml:1, fontSize:"24px", backgroundColor:"#FFFFFF"}}/>
              </Tooltip>
            </InputLabel>
            <OutlinedInput
              required
              error={newPasswordError}
              type={values.shownewPassword ? 'text' : 'password'}
              value={values.newpassword}
              onChange={handleChange('newpassword')}
              onKeyUp={handleValidation}
              name="newpassword"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickNewShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {!values.shownewPassword ? <img src="/assets/eye_close.png" alt=""/> : <img src="/assets/eye_open.png" alt=""/>}
                  </IconButton>
                </InputAdornment>
              }
              label="newpassword"

            />
            <Typography align='left' sx={{color:"#ED1C24", fontWeight:"500", fontSize:"16px"}}>{newPasswordError}&nbsp;</Typography>
          </FormControl>



          <FormControl fullWidth sx={{width: '100%' }} variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
            <OutlinedInput
              required
              error={confirmPasswordError}
              type={values.showconfirmPassword ? 'text' : 'password'}
              value={values.confirmpassword}
              onKeyUp={handleValidation}
              onChange={handleChange('confirmpassword')}
              name="confirmpassword"
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickConfirmShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {!values.showconfirmPassword ? <img src="/assets/eye_close.png" alt=""/> : <img src="/assets/eye_open.png" alt=""/>}
                  </IconButton>
                </InputAdornment>
              }
              label="confirmpassword"
            />
            <Typography align='left' sx={{color:"#ED1C24", fontWeight:"500", fontSize:"16px"}}>{confirmPasswordError}&nbsp;</Typography>
          </FormControl>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          sx={{width: '100%'}}
        >
        <Button
         onClick={handleSubmit}
          sx={{width: 170, height:43, fontSize: 16, fontWeight:400, margin: 'auto', textTransform:"none" }} disabled={newPasswordError || confirmPasswordError  || values.confirmpassword.length===0} variant={'contained'} color={'primary'}>Reset password</Button>
        </Stack>

      </Stack>

      <Portal>
        <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" color={'primary'} sx={{textAlign: 'center'}}>
            {"Thank you!"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"  sx={{textAlign: 'center'}}>
              Your password has been reset successfully.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant={'contained'} color={'primary'} sx={{px: 5, marginX: 'auto'}} onClick={() => {



              navigator('/auth/login');


            }}>Ok</Button>
          </DialogActions>
        </Dialog>
      </Portal>


    </Container>
  )

}